// Default imports
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useQueryParam, StringParam } from "use-query-params";

import { TabLabels } from "./Tabs";
import TilesNew from "./TilesNew";

import { teamCompData } from "../data/components-team.data";

const Team = () => {
    const [preventScroll, setPreventScroll] = useQueryParam(
        "prsc",
        StringParam
    );

    const compData = teamCompData();

    // Tabs
    const tabs = [
        ...compData.allWpTeamCategory.nodes
            .filter((node) => node.count > 0)
            .map((node) => {
                return { name: node.name, id: node.slug };
            }),
    ];

    // Team
    const team = compData.allWpTeam.nodes
        .map((member) => {
            return {
                order: member.menuOrder,
                key: member.id,
                coverHeader: member.title,
                coverText: member.cptTeamMember.office,
                tileText: member.cptTeamMember.description,
                linkedInUrl: member.cptTeamMember.linkedinUrl,
                coverImage: member.featuredImage?.node,
                cat: member.teamCategories.nodes.map((node) => node.slug),
            };
        })
        .sort((a, b) => {
            return Number(a.order) < Number(b.order) ? -1 : 1;
        });

    const [activeCat, setActiveCat] = useQueryParam("cat", StringParam);

    const handleTabClick = ({ event, id }) => {
        event.preventDefault();
        setPreventScroll("true", "replaceIn");

        setActiveCat(id, "replaceIn");
    };

    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <>
            {/* Tabs list */}
            <TabLabels
                className="py-2 -filter-tags"
                buttonVariant="small,deepblue"
                labels={tabs.map((item) => ({
                    label: item.name,
                    active: item.id === (activeCat ? activeCat : "board"),
                    onClick: (e) => handleTabClick({ event: e, id: item.id }),
                }))}
            />

            {/* Partners */}
            <TilesNew
                items={team}
                activeCat={activeCat ? activeCat : "board"}
                isLoaded={isLoaded}
            />
        </>
    );
};

export default Team;
